import React from 'react';
import { SettingValue, SettingsIssue } from '../../api/intercomSettings';

interface Props {
  field: string;
  label: string;
  type: 'boolean' | 'string' | 'number';
  value: SettingValue | undefined;
  onChange: (value: SettingValue) => void;
  issue?: SettingsIssue;
  hint?: string;
}

export const SettingsField: React.FC<Props> = ({ field, label, type, value, onChange, issue, hint }) => {
  const describedBy = issue ? `${field}-issue` : hint ? `${field}-hint` : undefined;
  const blocked = Boolean(issue && value !== true);
  return (
    <div className={`intercom-settings-field ${issue ? 'intercom-settings-field--issue' : ''}`}>
      {type === 'boolean' ? (
        <label className="intercom-settings-field__switch">
          <input
            aria-label={label}
            aria-describedby={describedBy}
            type="checkbox"
            checked={value === true}
            disabled={blocked}
            onChange={(event) => onChange(event.target.checked)}
          />
          <span><strong>{label}</strong>{hint && <small id={`${field}-hint`}>{hint}</small>}</span>
        </label>
      ) : (
        <label>
          <strong>{label}</strong>
          <input
            aria-label={label}
            aria-describedby={describedBy}
            type={type === 'number' ? 'number' : 'text'}
            value={value == null ? '' : String(value)}
            disabled={blocked}
            onChange={(event) => onChange(type === 'number' ? Number(event.target.value) : event.target.value)}
          />
          {hint && <small id={`${field}-hint`}>{hint}</small>}
        </label>
      )}
      {issue && <p id={`${field}-issue`} role="alert">{issue.remediation}</p>}
    </div>
  );
};
